//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios"

export default {
  name: 'Home',
  components: {
  },
  data: function() {
    return {
      patterns: [],
      playlists: [],
      loaded: false
    }
  },
  methods: {
    openPlaylist: function(pname) {
      this.$router.push("/library/playlist/" + pname);
    },
    newPlaylist: async function() {
      this.$q.loading.show({
        delay: 100 // ms
      })
      let playlistFile = "466-Erase.thr";
      var formData = new FormData();
      var blob = new Blob([playlistFile], {type: "text/plain"});
      formData.append("file", blob, "333-new_playlist.seq");
      await axios.post(this.$root.baseURL + "/uploadtofileman", formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
      });
      this.$q.loading.hide()
      this.$toasted.success('Playlist created!', {
        duration: 750
      })
      this.refreshFiles();
    },
    refreshFiles: async function(done) {
      await axios.get(this.$root.baseURL + "/filelist").then((response) => {
        this.patterns = [];
        this.playlists = [];
        response.data.files.forEach(file => {
          if(file.name.includes(".thr")) {
            //thr
            this.patterns.push(file);
          } else if(file.name.includes(".seq")) {
            //sequence / playlist
            axios.get(this.$root.baseURL + "/files/sd/" + file.name).then((response) => {
              const lines = response.data.split("\n");
              file.itemCount = lines.length
              file.preview = [
                "/images.png",
                "/images.png",
                "/images.png",
                "/images.png"
              ]
              try { file.preview[0] = 'https://webcenter.sisyphus-industries.com/uploads/track/thr/' + lines[0].split("-")[0] + '/thumb_400.png'; } catch(e) {}
              try { file.preview[1] = 'https://webcenter.sisyphus-industries.com/uploads/track/thr/' + lines[1].split("-")[0] + '/thumb_400.png'; } catch(e) {}
              try { file.preview[2] = 'https://webcenter.sisyphus-industries.com/uploads/track/thr/' + lines[2].split("-")[0] + '/thumb_400.png'; } catch(e) {}
              try { file.preview[3] = 'https://webcenter.sisyphus-industries.com/uploads/track/thr/' + lines[3].split("-")[0] + '/thumb_400.png'; } catch(e) {}
              this.playlists.push(file);
            })
          }
        });
      });
      this.playlists.push({name: "All Tracks.seq"});
      done();
    }
  },
  mounted: async function() {
    this.$q.loading.show({
        delay: 100 // ms
    })
    await this.refreshFiles(function() {});
    this.$q.loading.hide();
    this.loaded = true;
  }
}
